import React from 'react';
import PropTypes from 'prop-types';
import { Avatar, InformationItem, Text } from '@stashinvest/react-components';
import { Flex, PrimaryButton, SecondaryButton, Box } from '@stashinvest/ui';
import {
	BankIcon,
	NumberCircleOneIcon,
	NumberCircleThreeIcon,
	NumberCircleTwoIcon,
} from '@stashinvest/react-assets';
import { BanjoString } from '@stashinvest/react-banjo';

const introInformationItems = [
	{
		icon: <NumberCircleOneIcon />,
		text: <BanjoString stringId={'information/instruct/externalBankDetails'} />,
	},
	{
		icon: <NumberCircleTwoIcon />,
		text: <BanjoString stringId={'information/giveContext/microDeposits'} />,
	},
	{
		icon: <NumberCircleThreeIcon />,
		text: <BanjoString stringId={'information/instruct/microDepositVerification'} />,
	},
];

const renderInformationItems = (items) => {
	return items.map((item, index) => {
		return (
			<InformationItem
				key={index}
				variant={{
					icon: item.icon,
					text: item.text,
					type: 'icon',
				}}
			/>
		);
	});
};

const LinkBankMicrosIntro = ({ next, linkInstantly }) => {
	return (
		<Box className="px-contentSmall">
			<Flex flexDirection="column" alignItems="center">
				<Avatar
					shape="square"
					backgroundType="fill"
					variant={{
						type: 'icon',
						Icon: BankIcon,
						size: 'medium',
						variant: 'neutral',
					}}
				/>
			</Flex>
			<Text textStyle="headerSmall" className="py-layoutXS" textAlign="center">
				Manual Bank Linking
			</Text>
			<div className="mb-contentLarge">
				{renderInformationItems(introInformationItems)}
			</div>
			<Flex
				flexDirection={{
					mobile: 'column',
					tablet: 'row-reverse',
				}}
			>
				<PrimaryButton
					mb="m"
					ml={{ tablet: 'xs' }}
					onClick={() => {
						next();
					}}
				>
					<BanjoString stringId={'action/progress/nextScreen'} />
				</PrimaryButton>
				<SecondaryButton
					mr={{ tablet: 'xs' }}
					onClick={() => {
						linkInstantly();
					}}
				>
					<BanjoString stringId={'action/startTask/instantLink'} />
				</SecondaryButton>
			</Flex>
		</Box>
	);
};

LinkBankMicrosIntro.propTypes = {
	next: PropTypes.func,
	linkInstantly: PropTypes.func,
};

export default LinkBankMicrosIntro;
